module.exports = __webpack_public_path__ + "static/use-cases-0703456d53d152b8ae454cb716e7d499.png";